module.exports = __webpack_public_path__ + "media/images/brand/newsletter/cave_man_800-138b16ac5606191631f473e4acf98222.png";